/* eslint-disable no-unused-vars */

export const initialState = {
  documentTemplate: {
    documentTemplateId: null,
    templateName: '',
    exportType: 'Aspose',
    sharepointContentType: '',
    needsSigning: false,
    documentTypeId: null,
    requiresAllDocs: false,
    uspName: '',
    outputType: null,
    saveOnLocalDisk: false,
    localDiskSavePath: '',
    localDiskFileName: '',
    sharepointUse: false,
    filterCondition: '',
    displayOrder: null,
    mailMergeSP: '',
    targetAreaId: null,
    hasMetadata: false,
    templateCode: '',
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnDocumentTemplateAdded':
      return onDocumentTemplateAdded(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state);
    default:
      return state;
  }
}

function onHeaderSaved(state) {
  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      changed: false
    }
  };
}

function onInitState(state, action) {
  const {
    documentTemplateFilters,
    documentTemplateXOptionBookmarks,
    documentTemplateXSignatures,
    documentTemplateXUserGroups,
    signatureBookmarks,
    ...docTemplate
  } = action.docTemplate;
  return {
    ...state,
    documentTemplate: {
      ...docTemplate,
      changed: false
    }
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;
  let uniqueByDocumentCalculated = state.documentTemplate.uniqueByDocument;

  if (propertyName === 'targetAreaId' && value !== -1) uniqueByDocumentCalculated = false;

  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      uniqueByDocument: uniqueByDocumentCalculated,
      [propertyName]: value,
      changed: true
    }
  };
}

function onDocumentTemplateAdded(state, action) {
  const { bulkPrintingYN } = action;

  return {
    ...state,
    documentTemplate: {
      ...state.documentTemplate,
      bulkPrintingYN
    }
  };
}
